import { render, staticRenderFns } from "./explore2.vue?vue&type=template&id=0a06553c&scoped=true&"
import script from "./explore2.vue?vue&type=script&lang=js&"
export * from "./explore2.vue?vue&type=script&lang=js&"
import style0 from "./explore2.vue?vue&type=style&index=0&id=0a06553c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06553c",
  null
  
)

export default component.exports